const wrapper = "_35swp2hsqs";
const content = "_35sc13drg5f";

export { content, wrapper };
import "./_dropzone.style.linaria.module.css";
//# sourceMappingURL=_dropzone.style.js.map
